import { useTranslation } from 'react-i18next';
import { HeaderActionType } from '../../../../SharedComponents/Header/HeaderActionType';
import {
    ButtonResource,
    HeaderResource,
    ImageResource,
    TextResource,
} from '../../../../Utils/PageUtils';

export type HearingProfileResultPageResource = {
    header: HeaderResource;
    instructionImage: ImageResource;
    instruction: TextResource;
    continueButton: ButtonResource;
};

export default function useHearingProfileResultPageResource(): HearingProfileResultPageResource {
    const { t } = useTranslation();

    const header = {
        id: 'hearing-result-header',
        text: t(`common:Common_Feature:HearingProfileCheck`),
        prefix: `2.`,
        type: HeaderActionType.Menu,
    };

    const instructionImage = {
        id: 'img-successful',
        src: `/resources/shared/successful_tick-mark.svg`,
        alt: 'initialSettings:resultPage:header',
    };
    const instruction = {
        id: 'resultPage-instruction',
        text: t(`initialSettings:InitialSettings_Feature:ResultPage:Text`),
    };
    const continueButton = {
        label: t(
            `initialSettings:InitialSettings_Feature:ResultPage:NextButton`
        ),
        id: 'btn-apply',
    };

    return {
        header,
        instructionImage,
        instruction,
        continueButton,
    };
}
